import { CartItemFragment } from '@graphcommerce/magento-cart-items'

export const klaviyoAddToCart = (
  addedItem: CartItemFragment,
  quantity: number,
  category: string,
) => {
  if (addedItem && addedItem.prices && addedItem.prices.row_total_including_tax.value) {
    // we need to manually calculate pricePerItemInclTax (https://github.com/magento/magento2/issues/33848)
    const pricePerItemInclTax = addedItem.prices.row_total_including_tax.value / addedItem.quantity
    const addToCartValue = pricePerItemInclTax * quantity
    const _learnq = globalThis._learnq || []

    _learnq.push([
      'track',
      'Added to Cart',
      {
        $value: addToCartValue,
        AddedItemProductName: addedItem?.product.name,
        AddedItemProductID: addedItem?.product?.uid,
        AddedItemSKU: addedItem?.product?.sku,
        AddedItemCategories: [category],
        AddedItemImageURL: addedItem?.product.thumbnail?.url,
        AddedItemURL: new URL(
          `${import.meta.graphCommerce.canonicalBaseUrl}p/${addedItem.product?.url_key}`,
        ).href,
        AddedItemPrice: addedItem.prices.row_total_including_tax.value,
        AddedItemQuantity: addedItem.quantity,
        CheckoutURL: new URL(`${import.meta.graphCommerce.canonicalBaseUrl}checkout`).href,
        Items: [
          {
            Name: addedItem?.product.name,
            Qty: addedItem.quantity,
            Price: addedItem.prices.row_total_including_tax.value,
            Product: {
              FirstImageURL: addedItem?.product.thumbnail?.url,
              FullURL: new URL(
                `${import.meta.graphCommerce.canonicalBaseUrl}p/${addedItem.product?.url_key}`,
              ).href,
            },
          },
        ],
      },
    ])
  }
}
